import {
  NBS_WS_USER_DATA,
  NBS_API_FAVORITE_USER_SUCCESS
} from '../../constants/actions';

const initialState = {};

export default function userData (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_WS_USER_DATA:
      const userData = {[`${action.data['user_id']}`]: action.data};
      return {
        ...state,
        ...userData
      };
    case NBS_API_FAVORITE_USER_SUCCESS:
      const userDataToChangeFavoriteStatus = {...state[action.data['user_id']]};
      const newUserDateWithChangedFavoritesStatus = {[`${action.data['user_id']}`]: {...userDataToChangeFavoriteStatus, ...{'favorited': !!action.data.set}}};
      return {...state, ...newUserDateWithChangedFavoritesStatus};
    default:
      return state;
  }
}
